import { AnyString, ProfileRole } from "types";

export const mapRoleToUX = (role: ProfileRole | AnyString) => {
  switch (role) {
    case "admin":
      return "Admin";
    case "reader":
      return "Viewer";
    case "writer":
      return "Editor";
    default:
      return role;
  }
};
